import React, { useEffect } from "react";
import {
  createHashRouter,
  createRoutesFromElements,
  Outlet,
  Route,
} from "react-router-dom";
import "./App.css";

import { DrawerContent } from "../pages/drawer";
import { HeaderContent } from "../pages/header";

import {
  css,
  registerStyles,
} from "@vaadin/vaadin-themable-mixin/register-styles";

import { HomePage } from "../pages/home";
import { InterfaceRequirementListPage } from "../pages/interface-requirement-list";
import { PartnerListPage } from "../pages/partner-list";
import { WebComponentsPage } from "../pages/web-components";

import {
  FrVrfContextSetter,
  GlobalAlertBar,
  GlobalConfirmationDialog,
  GlobalLoading,
  GlobalToast,
} from "@vrf/fr-vrf-core-react";
import { AlertBarForMultipleErrorMessages } from "../componentns/alert-bar-for-multiple-error-messages";
import { ScreenAuthorization } from "../componentns/screen-authorization";
import { ComponentAdditionPage } from "../pages/component-addition";
import { ComponentDeploymentRequestListPage } from "../pages/component-deployment-request-list/ComponentDeploymentRequestListPage";
import { ComponentDetailPage } from "../pages/component-detail";
import { ComponentListPage } from "../pages/component-list";
import { ComponentProjectDetailPage } from "../pages/component-project-detail";
import { ComponentProjectListPage } from "../pages/component-project-list";
import { ComponentProjectListRequestPage } from "../pages/component-project-list-request";
import { DataKindMaintenancePage } from "../pages/data-kind-maintenance";
import { DeploymentRequestDetailPage } from "../pages/deployment-request-detail";
import { DeploymentRequestListPage } from "../pages/deployment-request-list";
import { EdhProtocolAttributePage } from "../pages/edh-protocol-attribute";
import { EnvironmentCopyPage } from "../pages/environment-copy";
import { FileLayoutMaintenancePage } from "../pages/file-layout-maintenance";
import { InterfaceListPage } from "../pages/interface-definitions";
import { PartnerDetailPage } from "../pages/partner-detail";
import { ProjectDetailPage } from "../pages/project-detail";
import { ProjectPlanPage } from "../pages/project-plan";
import { ProjectSearchPage } from "../pages/project-search";
import { RootComponentListPage } from "../pages/root-component-list";
import { TicketDetailPage } from "../pages/ticket-detail";
import { useAppState } from "./useAppState";
import { UserRoleMaintenancePage } from "../pages/user-role-maintenance";
import { useLocation } from "react-router-dom";
import { registerPopStateBlocker, setCurrentIndex } from "../blocker";

registerPopStateBlocker();

export const AppContent: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const currentIndex = window.history.state?.idx;
    if (currentIndex == null) return;
    setCurrentIndex(currentIndex);
  }, [location]);

  const [appState, _setAppState] = useAppState();
  registerStyles(
    "vaadin-app-layout",
    css`
      [part="drawer"] {
        width: 20% !important;
      }
    `,
  );

  return (
    <FrVrfContextSetter>
      <ScreenAuthorization>
        <vaadin-app-layout id="app-root">
          <div
            slot="navbar"
            className={appState.isGodMode ? "header god" : "header"}
          >
            <HeaderContent />
          </div>
          <div slot="drawer" className="drawer">
            <DrawerContent />
          </div>
          <div className="content">
            <GlobalAlertBar></GlobalAlertBar>
            <AlertBarForMultipleErrorMessages></AlertBarForMultipleErrorMessages>
            <Outlet />
            <GlobalLoading></GlobalLoading>
            <GlobalToast></GlobalToast>
            <GlobalConfirmationDialog></GlobalConfirmationDialog>
          </div>
        </vaadin-app-layout>
      </ScreenAuthorization>
    </FrVrfContextSetter>
  );
};

const routes = createRoutesFromElements(
  <Route element={<AppContent />}>
    <Route path="/" element={<HomePage />} />
    <Route path="/project-search" element={<ProjectSearchPage />} />
    <Route path="/project-plan" element={<ProjectPlanPage />} />
    <Route path="/project-detail" element={<ProjectDetailPage />} />
    <Route
      path="/component-project-list"
      element={<ComponentProjectListPage />}
    />
    <Route
      path="/component-project-list-request"
      element={<ComponentProjectListRequestPage />}
    />
    <Route
      path="/component-project-detail"
      element={<ComponentProjectDetailPage />}
    />
    <Route path="/interface-list" element={<InterfaceListPage />} />
    <Route
      path="/data-kind-maintenance"
      element={<DataKindMaintenancePage />}
    />
    <Route
      path="/file-layout-maintenance"
      element={<FileLayoutMaintenancePage />}
    />
    <Route
      path="/interface-deployment-request-list"
      element={<DeploymentRequestListPage />}
    />
    <Route
      path="/deployment-request-detail"
      element={<DeploymentRequestDetailPage />}
    />
    <Route path="/root-component-list" element={<RootComponentListPage />} />
    <Route path="/component-list" element={<ComponentListPage />} />
    <Route path="/component-detail" element={<ComponentDetailPage />} />
    <Route path="/component-addition" element={<ComponentAdditionPage />} />
    <Route
      path="/edh-protocol-attribute"
      element={<EdhProtocolAttributePage />}
    />
    <Route
      path="/component-deployment-request-list"
      element={<ComponentDeploymentRequestListPage />}
    />
    <Route path="/partner-list" element={<PartnerListPage />} />
    <Route path="/partner-detail" element={<PartnerDetailPage />} />
    <Route path="/ticket-detail" element={<TicketDetailPage />} />
    <Route
      path="/interface-requirement-list"
      element={<InterfaceRequirementListPage />}
    />
    <Route path="/environment-copy" element={<EnvironmentCopyPage />} />
    <Route
      path="/user-role-maintenance"
      element={<UserRoleMaintenancePage />}
    />
    {/* Develop */}
    <Route path="/web-components" element={<WebComponentsPage />} />
    <Route path="*" element={null} />
  </Route>,
);
export const router = createHashRouter(routes);
